import { env } from '../env';

export const apiConstants = {
  API_URL: env.VITE_API_BASE_URL,
  STREAMING_SERVER_URL: env.VITE_STREAMING_SERVER_URL || 'https://iothub.webtrack.online'
};
